import * as React from 'react'
import { useDrag } from 'react-dnd'

import {
  insertSectionBlock,
  moveSectionBlock,
} from '@disco/state-management/actions/campaign-editor-actions'
import type { SectionBlock } from 'types/content-editor'

import { useDispatch } from 'hooks/use-redux'

import { SECTION_BLOCK } from './constants'

type DragItem = {
  type?: SectionBlock
  sectionIndex?: number
}

type DropResult = {
  sectionIndex: number
}

type Props = {
  type?: SectionBlock
  sectionIndex?: number
  children: React.ReactElement
}

export default function BlockDragWrapper({
  type,
  sectionIndex,
  children,
}: Props) {
  const dispatch = useDispatch()
  const [, drag] = useDrag<DragItem, DropResult, unknown>(
    () => ({
      type: SECTION_BLOCK,
      item: { type, sectionIndex },
      end: (item, monitor) => {
        if (!monitor.didDrop()) return
        const dropResult = monitor.getDropResult()
        if (!dropResult) return
        const { sectionIndex: targetSectionIndex } = dropResult
        if (typeof item.sectionIndex === 'number') {
          dispatch(moveSectionBlock(item.sectionIndex, targetSectionIndex))
        } else if (item.type) {
          dispatch(insertSectionBlock(targetSectionIndex, item.type))
        }
      },
    }),
    [dispatch, type, sectionIndex],
  )

  return drag(children)
}
